import { createAction, props } from '@ngrx/store';

import { Application, Proposal, Quote } from '@lockton-apps/shared/interfaces';

export enum ProposalStepActionTypes {
  Init = '[Proposals Step] Init',
  SaveProposal = '[Proposals Step] Save Proposal',
  AutoSaveProposal = '[Proposals Step] Auto Save Proposal',
  SubmitStep = '[Proposals Step] Submit Step',
  SubmitProposal = '[Proposals Step] Submit Proposal',
  SubmitProposalConfirmed = '[Proposals Step] Submit Proposal Confirmed',
  AdditionalProductsSet = '[Proposals Step] Additional Products Set',
  QuoteReleased = '[Proposals Step] Quote Released',
  CriteriaConfirmationDialogOpened = '[Proposals Step] Criteria Confirmation Dialog Opened',
  QuoteApproved = '[Proposals Step] Quote Approved',
  ConnectionLost = '[Proposals Step] Connection Lost',
  ConnectionRestored = '[Proposals Step] Connection Restored',

  // v2
  ProposalReturned = '[Proposals Step] Proposal Returned',
  InviteSent = '[Proposals Step] Invite Sent',
}

export const ProposalStepActions = {
  init: createAction(ProposalStepActionTypes.Init),

  saveProposal: createAction(
    ProposalStepActionTypes.SaveProposal,
    props<{ proposal: Proposal }>()
  ),

  autoSaveProposal: createAction(
    ProposalStepActionTypes.AutoSaveProposal,
    props<{ proposal: Proposal }>()
  ),

  submitStep: createAction(
    ProposalStepActionTypes.SubmitStep,
    props<{ proposal: Proposal }>()
  ),

  submitProposal: createAction(
    ProposalStepActionTypes.SubmitProposal,
    props<{ proposal: Proposal }>()
  ),

  submitProposalConfirmed: createAction(
    ProposalStepActionTypes.SubmitProposalConfirmed,
    props<{ proposal: Proposal; quote: Quote }>()
  ),

  additionalProductsSet: createAction(
    ProposalStepActionTypes.AdditionalProductsSet,
    props<{ proposalId: string; application: Partial<Application> }>()
  ),

  quoteReleased: createAction(
    ProposalStepActionTypes.QuoteReleased,
    props<{ quoteId: number }>()
  ),

  criteriaConfirmationDialogOpened: createAction(
    ProposalStepActionTypes.CriteriaConfirmationDialogOpened,
    props<{ quoteId: number }>()
  ),

  quoteApproved: createAction(
    ProposalStepActionTypes.QuoteApproved,
    props<{ quoteId: number; comment: string }>()
  ),

  connectionLost: createAction(ProposalStepActionTypes.ConnectionLost),

  connectionRestored: createAction(ProposalStepActionTypes.ConnectionRestored),

  // v2
  proposalReturned: createAction(
    ProposalStepActionTypes.ProposalReturned,
    props<{ quote: Quote }>()
  ),

  inviteSent: createAction(
    ProposalStepActionTypes.InviteSent,
    props<{ quote: Quote }>()
  ),
};
